import { Box, Grid, List, Stack, Typography } from "@mui/joy"
import { ListItem } from "@mui/material"
import { useDispatch } from "react-redux"
import { Link } from "react-router-dom"
import { triggerSair } from "../auth/AuthenticationSlice"

var styles = {
    navbar: {
        position: "relative",
        top: 0,
        boxShadow: "0px 1px 10px 1px",
        marginBottom: "5px",
        backgroundColor: "#DEDEDE",
        height: "40px",
        width: "100%"
    }
}

function NavBar() {

    var dispatch = useDispatch();

    return <Box sx={
        !window.location.href.includes("localhost") ?
            styles.navbar :
            { ...styles.navbar, backgroundColor: "#97df97" }
    }>
        <Grid container>
            <Grid xs={12}>
                <Stack direction="row">
                    <List orientation="horizontal">
                        <ListItem>
                            <Typography>
                                <Link to="/estoque">Estoque</Link>
                            </Typography>
                        </ListItem>
                        <ListItem>
                            <Typography>
                                <Link to="/clientes">Clientes</Link>
                            </Typography>
                        </ListItem>
                        <ListItem>
                            <Typography>
                                <Link to="/relatorios">Relatorios</Link>
                            </Typography>
                        </ListItem>
                        <ListItem>
                            <Typography>
                                <Link onClick={() => {
                                    dispatch(triggerSair())
                                }}>Sair</Link>
                            </Typography>
                        </ListItem>
                    </List>
                    <Box style={{
                        padding: "5px 10px",
                        justifyContent: "flex-end",
                        display: "flex",
                        width: "100%",
                        alignItems: "center"
                    }}>
                    </Box>
                </Stack>
            </Grid>
        </Grid>
    </Box>
}

export default NavBar